import { Table } from 'antd'
import React from 'react'

export default function VendorPreviewTable({ data, blank }) { 
  return (
      <Table dataSource={data} rowKey={(r) => r.id}>
          <Table.Column title="Name" key="name" dataIndex="name" />
          <Table.Column title="Short Code" key="short_code" dataIndex={!blank ? "short_code" : ''} />
          <Table.Column title="Street Address 1" key="street_address_1" dataIndex={!blank ? "street_address_1" : ''} />
          <Table.Column title="Street Address 2" key="street_address_2" dataIndex={!blank ? "street_address_2" : ''} />
          <Table.Column title="Phone" key="phone" dataIndex={!blank ? "phone" : ''} />
          <Table.Column title="City" key="city" dataIndex={!blank ? "city" : ''} />
          <Table.Column title="State" key="state" dataIndex={!blank ? "state" : ''} />
          <Table.Column title="Country" key="country" dataIndex={!blank ? "country" : ''} />
          <Table.Column title="Zipcode" key="zip" dataIndex={!blank ? "zip" : ''} />
          <Table.Column title="Routing Number" key="po_box" dataIndex={!blank ? "po_box" : ''} />
          <Table.Column title="W-9 Name" key="tariffs_link" dataIndex={!blank ? "tariffs_link" : ''} />
          <Table.Column title="Accounting Number" key="payment_identifier" dataIndex={!blank ? "payment_identifier" : ''} />
          <Table.Column title="Payment Methods" key="payment_methods" dataIndex={!blank ? "payment_methods" : ''} />
        </Table>
  )
}